import React from 'react';
import { useSelector } from 'react-redux';
import { DiaryRootState } from 'appRoot/rootReducer';
import { rootDisplayActions } from 'app/reducers/display/slice';
import { openGlobalSearchModal, closeGlobalSearchModal } from 'app/reducers/globalSearchModal/slice';
import ToastDialogClean from 'design-v2/common/ToastDialogClean/ToastDialogClean';
import { useAppDispatch } from 'appRoot/Store';
import BlockoutModal from 'app/bookings/BlockoutModal/BlockoutModal';
import SharedTableModal from 'app/bookings/SharedTableModal/SharedTableModal';
import BookingConflictsModal from 'app/bookings/BookingConflictsModal/BookingConflictsModal';
import GlobalBookingSearchModal from 'app/bookings/GlobalBookingSearchModal/GlobalBookingSearchModal';


const GlobalViews = () => {
  const dispatch = useAppDispatch();

  const toastCleanPayload = useSelector((state: DiaryRootState) => state.rootDisplayReducer.toastCleanPayload);
  const globalSearchModal = useSelector((state: DiaryRootState) => state.globalSearchModalReducer);

  return (
    <div>
      <ToastDialogClean
        message={toastCleanPayload.message}
        warningText={toastCleanPayload.warningText}
        type={toastCleanPayload.type}
        subText={toastCleanPayload.subText}
        handleClose={() => dispatch(rootDisplayActions.clearToast())}
        actionText={toastCleanPayload.actionText}
        onAction={toastCleanPayload.onAction}
      />
      <BlockoutModal />
      <SharedTableModal />
      <BookingConflictsModal />
      <GlobalBookingSearchModal
        isOpen={globalSearchModal.isOpen}
        onRequestClose={() => dispatch(closeGlobalSearchModal())}
        filterDate={globalSearchModal.filterDate ? new Date(globalSearchModal.filterDate) : undefined}
      />
    </div>
  );
}

export default GlobalViews;
